// src/components/themes/default/store/branch/BranchNavbar.tsx
"use client";

import { Phone, MapPin } from "lucide-react";

interface BranchNavbarProps {
  branch?: {
    id?: number;
    name?: string;
    slug?: string;
    contact_phone?: string;
    address?: string;
  } | null;
  announcementText?: string;
  primaryColor?: string;
}

export default function BranchNavbar({
  branch,
  announcementText,
  primaryColor = "#059669",
}: BranchNavbarProps) {
  const safeBranch = branch || {
    id: 0,
    name: "Branch Outlet",
    slug: "",
    contact_phone: "",
    address: "",
  };

  return (
    <div
      style={{ backgroundColor: primaryColor }}
      className="w-full text-white text-[11px] sm:text-xs font-bold py-2 px-4 shadow-xs transition-colors"
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-3">
        {/* Left Side: Announcement Text */}
        <div className="flex items-center gap-2 min-w-0">
          <span className="w-2 h-2 rounded-full bg-white animate-pulse shrink-0" />
          <span className="truncate">
            {announcementText || `Welcome to ${safeBranch.name || "Branch"} Official Outlet Store!`}
          </span>
        </div>

        {/* Right Side: Contact Phone & Outlet Location */}
        <div className="hidden sm:flex items-center gap-4 text-[11px] shrink-0 font-medium">
          {safeBranch.contact_phone && (
            <a
              href={`tel:${safeBranch.contact_phone}`}
              className="flex items-center gap-1.5 hover:underline transition-all font-mono"
            >
              <Phone className="w-3.5 h-3.5" />
              <span>{safeBranch.contact_phone}</span>
            </a>
          )}
          {safeBranch.address && (
            <span className="flex items-center gap-1.5 opacity-90 max-w-xs truncate">
              <MapPin className="w-3.5 h-3.5 shrink-0" />
              <span className="truncate">{safeBranch.address}</span>
            </span>
          )}
        </div>
      </div>
    </div>
  );
}